module.exports = __webpack_public_path__ + "static/img/pl.562edca5.svg";